import * as React from "react";

import { useUpdateTableCellOnResize } from "../../../Utils/useUpdateTableCellOnResize";

import { BaselineHackText, Root } from "./CrossfitTableBodyColumn.styles";

interface CrossfitTableBodyColumnProps {
    colSpan?: number;
    rowSpan?: number;
    indent?: "1" | "2" | "3" | "4" | "5";
    empty?: boolean;
    requiredEmpty?: boolean;
    isNumber?: boolean;
    grouped?: boolean;
    align?: "baseline" | "top";
    horizontalAlign?: "center" | "left" | "right";
    children: React.ReactNode | readonly React.ReactNode[];
}

export const CrossfitTableBodyColumn = (props: CrossfitTableBodyColumnProps) => {
    if (props.grouped) {
        return <>{props.children}</>;
    }
    return <CrossfitTableBodyColumnView {...props} />;
};

export const CrossfitTableBodyColumnView = (props: CrossfitTableBodyColumnProps) => {
    const { cellRef, contentRef } = useUpdateTableCellOnResize();
    return (
        <Root
            ref={cellRef}
            indent={Number(props.indent)}
            empty={props.empty || props.requiredEmpty}
            number={props.isNumber}
            colSpan={props.colSpan}
            rowSpan={props.rowSpan}
            horizontalAlign={props.horizontalAlign}>
            <div ref={contentRef}>
                {props.align === "baseline" && <BaselineHackText />}
                {props.empty ? "×" : props.children}
            </div>
        </Root>
    );
};
